import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    horizontalContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    cards: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: Spacings.s40,
      margin: '0 auto',
    },
    description: {
      marginBottom: Spacings.s24,
    },
    title: {
      marginBottom: Spacings.s32,
    },
    cardsButton: {
      marginTop: Spacings.s24,
    },
  },
  { name: 'CardsSection' },
);
